import component from './zh-CN/component';
import dashboard from './zh-CN/dashboard';
import globalHeader from './zh-CN/globalHeader';
import menu from './zh-CN/menu';
import pages from './zh-CN/pages';
import products from './zh-CN/products';
import orders from './zh-CN/orders';
import admin from './zh-CN/admin';
import pwa from './zh-CN/pwa';
import settingDrawer from './zh-CN/settingDrawer';
import settings from './zh-CN/settings';
import account from './zh-CN/account';

export default {
  'navBar.lang': '语言',
  'layout.user.link.help': '帮助',
  'layout.user.link.privacy': '隐私',
  'layout.user.link.terms': '条款',
  'app.preview.down.block': '下载此页面到本地项目',
  'app.welcome.link.fetch-blocks': '获取全部区块',
  'app.welcome.link.block-list': '基于 block 开发，快速构建标准页面',
  
  // 登录页面
  'pages.login.subtitle': '电商运营管理平台',
  'pages.login.username.placeholder': '请输入用户名',
  'pages.login.password.placeholder': '请输入密码',
  'pages.login.username.required': '请输入用户名!',
  'pages.login.password.required': '请输入密码！',
  'pages.login.success': '登录成功！',
  'pages.login.failure': '登录失败，请重试！',
  'pages.login.user.not.exist': '用户不存在',
  'pages.login.account.disabled': '用户账户未激活或已被停用',
  'pages.login.rememberMe': '记住登录',
  'app.request.error': '请求失败！',
  'media.preview': '预览',
  'media.videoPreview': '视频预览',
  ...pages,
  ...globalHeader,
  ...menu,
  ...settingDrawer,
  ...settings,
  ...pwa,
  ...component,
  ...dashboard,
  ...products,
  ...orders,
  ...admin,
  ...account,
};
